import React from "react";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import RefreshIcon from "@material-ui/icons/Refresh";

import "../css/screenshots.css";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  mainPage: (props) => ({
    zIndex: 0,
    marginLeft: props.userMenuOpen ? 260 : 0,
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  }),
  pollBackground: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  skeleton: {
    height: 320,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    border: "1px solid #afafaf",
    color: "#afafaf",
  },
});

function Screenshots(props) {
  const [urlIndex, setUrlIndex] = React.useState(props.urls.length - 1);

  React.useEffect(() => {
    setUrlIndex(props.urls.length - 1);
  }, [props.urls]);

  let mobile = props.width === "sm" || props.width === "xs";

  return (
    <div className={mobile ? "" : props.classes.mainPage}>
      <Container maxWidth="md">
        <Card className={props.classes.pollBackground} elevation={0}>
          <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1}>
            <Grid item md={6} xs={12}>
              <div className="screenshots-container">
                {props.urls.length > 0 && Boolean(props.urls[urlIndex]) ? (
                  <img className="screenshot" src={props.urls[urlIndex]}></img>
                ) : (
                  <div className={props.classes.skeleton}>
                    <Typography>Screenshots Unavailable</Typography>
                    {!props.sessionActive ? <Typography>No Session Active</Typography> : null}
                  </div>
                )}
                <div className="screenshot-controls">
                  <button disabled={urlIndex <= 0} onClick={() => setUrlIndex(urlIndex - 1)}>
                    <NavigateBeforeIcon />
                  </button>
                  <button onClick={props.refresh}>
                    <RefreshIcon />
                  </button>
                  <button disabled={urlIndex == props.urls.length - 1} onClick={() => setUrlIndex(urlIndex + 1)}>
                    <NavigateNextIcon />
                  </button>
                </div>
                <div className="screenshot-info">
                  <div>{`${urlIndex + 1} / ${props.urls.length}`}</div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { theme: true })(withWidth()(Screenshots))));
